import { isValidPhoneNumber } from 'libphonenumber-js/max'; // NOTE: use most strict validation (same as old checkout page)
import regex from '../shop/constants/regex';

export const validatePhoneWithCountry = ({ number, phoneCountry }) => {
  if (number.length === 0) {
    return false;
  }
  if (/[&^!@$_*%#`~=]/.test(number)) {
    return false;
  }
  if (phoneCountry === 'HK') {
    return /^[4-9]\d{7}$/.test(number);
  }
  return isValidPhoneNumber(number, phoneCountry);
};

export const validateEmail = (value) =>
  regex.EMAIL_REGEX.test(value) && regex.W3C_EMAIL_REGEX.test(value);

export const validateMailAndMobile = (value) =>
  regex.EMAIL_MOBILE_REGEX.test(value);
